<template>
    <div>
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <el-form-item label="标签名称:" prop="label">
                <el-input v-model="form.label"></el-input>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" size="small" @click="onSubmit('form')">{{ editID== 0 ? '添加' : '修改' }}</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    props: {
        editID: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            form: { label: '' },
            rules: {
                label: [
                    { required: true, message: '请输入标签名称', trigger: 'blur' },
                ]
            }
        }
    },
    methods: {
        onSubmit(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (!valid) {
                    this.$message.error("添加失败");
                    return false;
                }
                if (this.editID > 0) {
                    const { data: res } = await this.$axios.post(
                        "/label/editType",
                        this.form
                    );
                    console.log(res);
                    if (res.meta.status !== 200) return this.$message.error(res.meta.msg);
                    this.$emit("onDialog", false);
                    return this.$message.success(res.meta.msg);
                } else {
                    const { data: res } = await this.$axios.post(
                        "label/addtype",
                        this.form
                    );
                    console.log(res);
                    if (res.meta.status !== 200) return this.$message.error(res.meta.msg);
                    this.$emit("onDialog", false);
                    return this.$message.success(res.meta.msg);
                }
            });
        },
        async getLabel(id) {
            const { data: res } = await this.$axios.post("/label/getLabelId", {
                id: id,
            });
            console.log(res);
            this.form = res.data;
        },
    },
    created() {
        if (this.editID > 0) {
            console.log(this.editID);
            this.getLabel(this.editID);
        }
    },
}
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/components/articleLabel/addLabel.vue